export default [
  {
    id: 1,
    name: 'American Indian or Alaska Native',
    label: 'American Indian or Alaska Native',
    value: 'american_indian_or_alaska_native',
    subRaces: [],
  },
  {
    id: 2,
    name: 'Asian',
    label: 'Asian',
    value: 'asian',
    subRaces: [
      { id: 1, label: 'Asian India', value: 'asian_india' },
      { id: 2, label: 'Japanese', value: 'japanese' },
      { id: 3, label: 'Chinese', value: 'chinese' },
      { id: 4, label: 'Korean', value: 'korean' },
      { id: 5, label: 'Filipino', value: 'filipino' },
      { id: 6, label: 'Vietnamese', value: 'vietnamese' },
      { id: 7, label: 'Other Asian', value: 'other_asian' },
    ],
  },
  {
    id: 3,
    name: 'Black or African American',
    label: 'Black or African American',
    value: 'black_or_african_american',
    subRaces: [],
  },
  {
    id: 4,
    name: 'Native Hawaiian or Other Pacific Islander',
    label: 'Native Hawaiian or Other Pacific Islander',
    value: 'native_hawaiian_or_pacific_islander',
    subRaces: [
      { id: 8, label: 'Native Hawaiian', value: 'native_hawaiian' },
      { id: 9, label: 'Samoan', value: 'samoan' },
      { id: 10, label: 'Guamanian, Chamorro', value: 'guamanian_chamorro' },
      {
        id: 11,
        label: 'Other Pacific Islander',
        value: 'other_pacific_islander',
      },
    ],
  },
  {
    id: 5,
    name: 'White',
    label: 'White',
    value: 'white',
    subRaces: [],
  },
  {
    id: 6,
    name: 'Other',
    label: 'Other',
    value: 'other',
    subRaces: [],
  },
  {
    id: 7,
    name: 'Declined to Report',
    label: 'Declined to Report',
    value: 'declined_to_report',
    subRaces: [],
  },
];
